<template>
  <div v-if="GetShowType == 1" class="coupon-main-box platinum-member">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 195 52"
    >
      <path
        fill="#FFF"
        d="M156.121 28.899a1.881 1.881 0 01-2.666.032 1.89 1.89 0 01-.036-2.669 1.896 1.896 0 012.675-.032c.741.73.76 1.925.027 2.669"
      ></path>
      <path
        fill="#FFF"
        d="M153.42 26.262a1.888 1.888 0 002.701 2.637 1.885 1.885 0 00-1.351-3.204c-.487 0-.978.19-1.35.567"
      ></path>
      <defs>
        <path
          id="a"
          d="M153.42 26.263a1.888 1.888 0 002.701 2.637 1.889 1.889 0 00-.028-2.668 1.894 1.894 0 00-2.673.031"
        ></path>
      </defs>
      <clipPath id="b"><use xlink:href="#a" overflow="visible"></use></clipPath>
      <path
        clip-path="url(#b)"
        fill="#FFF"
        d="M152.696 25.695h4.154v3.966h-4.154z"
      ></path>
      <defs>
        <path
          id="c"
          d="M153.42 26.263a1.888 1.888 0 002.701 2.637 1.889 1.889 0 00-.028-2.668 1.894 1.894 0 00-2.673.031"
        ></path>
      </defs>
      <clipPath id="d"><use xlink:href="#c" overflow="visible"></use></clipPath>
      <path
        clip-path="url(#d)"
        fill="#FFF"
        d="M152.696 25.695h4.154v3.966h-4.154z"
      ></path>
      <path
        fill="#FFF"
        d="M25.473 17.738h4.381l5.698 8.368v-8.368h4.409v15.143h-4.409c-1.891-2.77-3.779-5.546-5.665-8.317v8.317h-4.414V17.738zM41.512 17.738h5.207c1.02 1.694 2.042 3.391 3.058 5.084 1.017-1.693 2.029-3.39 3.045-5.084h5.174c-1.96 2.935-3.924 5.869-5.887 8.802v6.341h-4.685V26.54l-5.912-8.802M85.52 23.879h1.968c.21 0 .624-.069 1.236-.206.309-.064.559-.221.757-.474a1.4 1.4 0 00.291-.876c0-.488-.154-.862-.46-1.123-.313-.26-.893-.391-1.74-.391H85.52v3.07zm-4.707 9.002V17.738h7.8c1.445 0 2.552.125 3.315.376a3.49 3.49 0 011.848 1.377c.469.673.702 1.491.702 2.456 0 .84-.177 1.568-.536 2.175a4.177 4.177 0 01-1.476 1.483c-.403.242-.949.442-1.645.6.559.187.963.372 1.219.557.171.124.421.389.746.795.33.407.548.719.659.938.753 1.465 1.507 2.925 2.262 4.386h-5.291c-.832-1.539-1.667-3.08-2.499-4.622-.312-.596-.596-.984-.842-1.166a1.968 1.968 0 00-1.143-.348h-.412v6.136h-4.707zM100.938 25.345c0 1.525.289 2.621.854 3.288.572.667 1.346 1 2.326 1 1.009 0 1.788-.327 2.339-.98.552-.653.825-1.823.825-3.516 0-1.42-.286-2.462-.862-3.12-.577-.653-1.354-.98-2.345-.98-.944 0-1.703.333-2.278.997-.57.668-.859 1.77-.859 3.311m-4.681-.024c0-2.469.69-4.392 2.067-5.769 1.382-1.374 3.299-2.063 5.761-2.063 2.524 0 4.468.676 5.833 2.029 1.37 1.353 2.05 3.243 2.05 5.68 0 1.769-.299 3.217-.893 4.349a6.378 6.378 0 01-2.586 2.642c-1.126.63-2.535.945-4.217.945-1.71 0-3.127-.271-4.246-.816-1.121-.543-2.027-1.404-2.727-2.58-.695-1.175-1.042-2.648-1.042-4.417M114.433 17.738h6.19l2.346 9.212c.782-3.07 1.568-6.141 2.355-9.212h6.163v15.143h-3.842V21.325l-2.953 11.556h-3.468c-.985-3.851-1.967-7.702-2.951-11.556v11.556h-3.84V17.738zM138.547 25.345c0 1.525.282 2.621.856 3.288.566.667 1.339 1 2.32 1 1.006 0 1.787-.327 2.338-.98.554-.653.829-1.823.829-3.516 0-1.42-.289-2.462-.862-3.12-.579-.653-1.359-.98-2.345-.98-.946 0-1.709.333-2.277.997-.576.668-.859 1.77-.859 3.311m-4.685-.024c0-2.469.692-4.392 2.066-5.769 1.38-1.374 3.301-2.063 5.761-2.063 2.527 0 4.47.676 5.837 2.029 1.366 1.353 2.047 3.243 2.047 5.68 0 1.769-.298 3.217-.895 4.349a6.368 6.368 0 01-2.584 2.642c-1.128.63-2.534.945-4.216.945-1.712 0-3.125-.271-4.249-.816-1.118-.543-2.027-1.404-2.722-2.58-.697-1.175-1.045-2.648-1.045-4.417M14.09 24.71l-2.355-7.769-2.361 7.769h4.716zm1.412 4.684H7.949a3053.49 3053.49 0 01-1.093 3.592H.027c2.702-7.216 5.407-14.43 8.105-21.648h7.349c2.702 7.218 5.403 14.432 8.1 21.648h-7.003l-1.076-3.592M66.981 20.495h1.639c1.286 0 2.197-.221 2.718-.667.522-.448.785-1.019.785-1.718 0-.678-.23-1.253-.681-1.724-.456-.474-1.306-.707-2.555-.707h-1.906v4.816zm-6.731-9.23h11.12c2.423 0 4.239.576 5.443 1.728 1.208 1.151 1.81 2.788 1.81 4.91 0 2.182-.656 3.888-1.973 5.119-1.31 1.226-3.313 1.842-6.008 1.842h-3.661v8.049H60.25V11.265zM164.962 29.437c0 1.837-.764 2.581-2.57 2.581h-.636c-2.012 0-2.679-.771-2.679-2.86v-1.452c0-2.089.667-2.857 2.679-2.857h.516c1.965 0 2.64.644 2.64 2.51v.136h-1.869v-.125c0-.656-.279-.877-.991-.877-.924 0-1.011.326-1.011 1.366v1.156c0 1.039.087 1.356 1.011 1.356.742 0 1.003-.231 1.003-.972v-.162h1.907v.2zM167.787 29.015c0 1.066.098 1.355 1.048 1.355h.349c.949 0 1.058-.289 1.058-1.355v-1.157c0-1.068-.109-1.366-1.058-1.366h-.349c-.95 0-1.048.298-1.048 1.366v1.157zm.762-4.17h.921c2.01 0 2.686.771 2.686 2.861v1.451c0 2.088-.676 2.858-2.686 2.858h-.921c-2.012 0-2.678-.77-2.678-2.858v-1.451c0-2.09.666-2.861 2.678-2.861M181.712 24.932v6.999h-1.829V26.79c-.466 1.715-.936 3.426-1.406 5.141h-1.875c-.47-1.735-.944-3.466-1.413-5.197v5.197h-1.83v-6.999h2.74c.482 1.691.957 3.376 1.434 5.062.482-1.686.958-3.371 1.438-5.062h2.741zM194.947 8.957C194.15 1.973 175.551-1.644 153.402.88c-15.282 1.741-28.254 5.95-34.572 10.687 6.736-3.135 16.503-5.726 27.529-6.985 21.204-2.415 39.006 1.02 39.767 7.674.408 3.597-4.261 7.401-11.98 10.518 12.863-3.574 21.363-8.878 20.801-13.817"
      ></path>
      <path
        fill="#FFF"
        d="M153.401.88c-15.282 1.741-28.253 5.952-34.571 10.686 6.737-3.135 16.502-5.724 27.528-6.984 21.205-2.416 39.007 1.021 39.768 7.673.408 3.597-4.261 7.401-11.98 10.518 12.863-3.573 21.364-8.875 20.801-13.816-.623-5.474-12.19-8.882-27.831-8.882-4.31 0-8.931.26-13.715.805"
      ></path>
      <defs>
        <path
          id="e"
          d="M153.401.88c-15.282 1.741-28.253 5.951-34.572 10.686 6.738-3.135 16.503-5.723 27.529-6.984 21.205-2.416 39.007 1.022 39.768 7.673.408 3.597-4.26 7.402-11.98 10.519 12.864-3.574 21.364-8.875 20.801-13.817-.623-5.474-12.19-8.881-27.83-8.881-4.312 0-8.931.258-13.716.804"
        ></path>
      </defs>
      <clipPath id="f"><use xlink:href="#e" overflow="visible"></use></clipPath>
      <path
        clip-path="url(#f)"
        fill="#FFF"
        d="M118.83.075h76.68v22.698h-76.68z"
      ></path>
      <path
        fill="#FFF"
        d="M147.729 5.917c-13.217 1.62-24.518 5.17-30.096 9.034 5.896-2.594 14.383-4.809 23.922-5.979 18.333-2.248 33.569.216 34.027 5.496.245 2.859-3.886 5.956-10.632 8.554 11.184-3.04 18.665-7.387 18.325-11.314-.476-5.541-16.393-8.138-35.546-5.791M32.624 38.757c.501 0 1.012.064 1.533.193.52.128 1.024.372 1.513.733.489.359.852.819 1.09 1.378.237.559.356 1.128.356 1.706 0 .578-.106 1.115-.318 1.61a3.698 3.698 0 01-.906 1.282 4.01 4.01 0 01-1.427.829 5.61 5.61 0 01-1.841.29h-4.107v4.897h-1.523V38.757h5.63zm0 6.651c.913 0 1.639-.243 2.178-.732.54-.488.81-1.125.81-1.909s-.27-1.421-.81-1.909c-.539-.488-1.265-.732-2.178-.732h-4.107v5.282h4.107zM49.434 51.675h-8.927V38.757h1.523v11.529h7.404zM62.602 51.675l-1.446-3.278h-6.807l-1.446 3.278h-1.639l5.785-12.919h1.407l5.785 12.919h-1.639zm-4.84-11.029l-2.815 6.381h5.611l-2.796-6.381zM71.064 40.126v11.549h-1.542V40.126H64.72v-1.37h11.125v1.37zM78.985 38.757h1.523v12.918h-1.523zM96.125 51.675h-1.312l-8.444-10.257v10.257h-1.524V38.757h1.311l8.446 10.373V38.757h1.523zM105.744 50.46c2.466 0 3.856-1.939 3.856-4.435v-7.269h1.523v7.269c0 2.744-1.255 4.654-3.2 5.476a5.534 5.534 0 01-2.179.424c-2.663 0-4.346-1.499-5.051-3.508a7.16 7.16 0 01-.386-2.392v-7.269h1.523v7.269c0 2.524 1.462 4.435 3.914 4.435M129.245 51.675h-1.467v-9.679l-5.09 9.679h-.79l-5.109-9.679v9.679h-1.466V38.757h1.33l5.631 10.643 5.63-10.643h1.331z"
      ></path>
    </svg>
    <h1>30-Day Free Trial!</h1>
    <h2 class="Galyon">Members Save on Average of $147 on:</h2>
    <ul class="Galyon-Bold">
      <li>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11">
          <path
            fill="none"
            stroke="#8DC63F"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            d="M1.954 6.346l2.439 2.749 4.653-7.19"
          ></path>
        </svg>
        Free Shipping
      </li>
      <li>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 11">
          <path
            fill="none"
            stroke="#8DC63F"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            d="M1.954 6.346l2.439 2.749 4.653-7.19"
          ></path>
        </svg>
        Free Samples
      </li>
    </ul>
    <a href="/free-trial-platinum" class="sign-up">Try It Today</a>
  </div>
  <div v-else-if="GetShowType == 2" class="coupon-main-box platinum-member" >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="107"
      height="23"
      style="width: 107px; height: 23px;"
    >
      <g fill="#FBB040">
        <path
          d="M53.741.731l2.956 5.78c.151.296.437.501.764.549l6.396.927c.825.119 1.172 1.131.586 1.711l-4.535 4.499a.991.991 0 00-.273.888l1.203 6.353a.987.987 0 01-1.436 1.057l-5.759-2.999a1.002 1.002 0 00-.934 0l-5.652 2.999c-.729.387-1.6-.238-1.474-1.057l.976-6.353a1.019 1.019 0 00-.304-.888l-4.696-4.499c-.606-.58-.295-1.592.526-1.711l6.362-.927a.982.982 0 00.745-.549l2.75-5.78c.354-.746 1.418-.746 1.799 0M81.231 6.617l2.102 4.111a.727.727 0 00.544.39l4.548.66c.587.085.834.804.418 1.217l-3.226 3.2a.703.703 0 00-.194.631l.856 4.519a.703.703 0 01-1.023.752l-4.095-2.133a.715.715 0 00-.664 0l-4.02 2.133c-.518.275-1.139-.169-1.049-.752l.695-4.519a.723.723 0 00-.217-.631l-3.34-3.2c-.431-.413-.21-1.132.374-1.217l4.525-.66a.696.696 0 00.531-.39l1.955-4.111c.252-.53 1.009-.53 1.28 0M26.457 7.265l2.102 4.111a.73.73 0 00.544.39l4.549.66c.587.085.833.804.417 1.217l-3.225 3.2a.704.704 0 00-.195.631l.856 4.519a.702.702 0 01-1.022.752l-4.096-2.133a.715.715 0 00-.664 0l-4.019 2.133c-.519.275-1.139-.169-1.049-.752l.694-4.519a.72.72 0 00-.217-.631l-3.34-3.2c-.43-.413-.21-1.132.374-1.217l4.525-.66a.694.694 0 00.531-.39l1.955-4.111c.253-.53 1.009-.53 1.28 0M6.478 11.23l1.509 2.95a.52.52 0 00.39.279l3.264.474c.421.061.598.577.299.873l-2.315 2.296a.507.507 0 00-.139.453l.614 3.242a.503.503 0 01-.733.54l-2.939-1.53a.508.508 0 00-.476 0l-2.885 1.53a.52.52 0 01-.752-.54l.498-3.242a.523.523 0 00-.155-.453L.261 15.806a.507.507 0 01.268-.873l3.247-.474a.498.498 0 00.381-.279l1.403-2.95c.181-.381.724-.381.918 0M101.29 11.301l1.509 2.95a.521.521 0 00.39.28l3.264.473c.421.061.598.577.299.873l-2.315 2.296a.505.505 0 00-.138.454l.613 3.241a.503.503 0 01-.733.54l-2.939-1.53a.508.508 0 00-.476 0l-2.885 1.53a.52.52 0 01-.752-.54l.498-3.241a.521.521 0 00-.155-.454l-2.397-2.296a.507.507 0 01.269-.873l3.246-.473a.501.501 0 00.381-.28l1.403-2.95c.181-.379.724-.379.918 0"
        ></path>
      </g>
    </svg>
    <p style="color: rgb(255, 255, 255); font-size: 30px;">
      Enjoyed your Platinum Perks?
    </p>
    <h1 v-if="customerMVPInfo.shippingSavings > 0" style="display: block; margin: 30px 0px;">
      You've saved <br /><span style="color: rgb(141, 198, 63);">{{ customerMVPInfo.shippingSavingsDesc }}</span>
      already!
    </h1>
    <h1 v-else style="display: block; margin: 30px 0px;">
      Members save on average of $150
    </h1>
    <h2 class="Galyon" style="margin: 20px 0px;">Continue the benefits!</h2>
    <a href="/platinum" class="sign-up" style="width: 170px;">Renew it Today</a>
  </div>
  <div v-else-if="GetShowType == 3" class="coupon-main-box platinum-member">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 42"
      style="width: 10px; height: 30px;"
    >
      <path
        fill="#EF4136"
        d="M.021 5.101V0h12.958v5.1L9.5 28.32h-6L.021 5.101zM.561 31.8H12.44V42H.561V31.8z"
      ></path>
    </svg>
    <h2 style="margin: 10px 0px; line-height: 1.3;">
      Your membership is about to end in
      <span style="color: rgb(239, 65, 54);">{{ customerMVPInfo.leftMVPDays }}</span> days!
    </h2>
    <p class="Galyon" style="margin: 20px 0px; color: rgb(153, 153, 153);">
      Take advantage of our
      <span class="Galyon-Bold">Platinum Perks</span> before time runs out!
    </p>
    <h1 class="Galyon" style="display: block; height: auto; font-size: 22px;">
      Check out these <br /><span class="Galyon-Bold">exclusive items</span
      ><br />for platinum members!
    </h1>
    <a href="/10-for-10-items" class="sign-up" style="margin-top: 20px;">Let's go</a>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { CustomerMVPModel } from '@/types/Customer'

export default defineComponent({
  name: 'PlatinumMemberBox',
  props: {
    customerMVPInfo: {
      type: Object as PropType<CustomerMVPModel>,
      default: () => { return {} }
    }
  },
  computed: {
    GetShowType (): number {
      let showType = 0
      const mvpInfo = this.customerMVPInfo
      if (mvpInfo == null) return 0
      if (mvpInfo.isLogined && mvpInfo.isMVP) {
        showType = 3
      } else {
        if (mvpInfo.isGetFreeTrailMVP) { showType = 2 } else { showType = 1 }
      }
      return showType
    }
  }
})
</script>

<style>
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
p{margin:0 0 10px;}
:focus{outline:0;}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
p{margin:0 0 10px;}
:focus{outline:0;}
.Galyon{font-family:Galyon, Helvetica, Arial, sans-serif;}
.Galyon-Bold{font-family:"Galyon Bold", Helvetica, Arial, sans-serif;}
.coupon-wrapper p{color:#7a7a7a;font-size:16px;margin:8px 0 0 0;line-height:1.2;}
@media (max-width: 540px){
.coupon-wrapper p{font-size:14px!important;}
}
.Galyon{font-family:Galyon, Helvetica, Arial, sans-serif;}
.Galyon-Bold{font-family:"Galyon Bold", Helvetica, Arial, sans-serif;}
.coupon-wrapper p{color:#7a7a7a;font-size:16px;margin:8px 0 0 0;line-height:1.2;}
.coupon-main-box{width:100%;border-radius:25px;height:124px;box-shadow:5px 10px 10px 0px #dedede;display:flex;align-items:center;justify-content:center;background:#fff;margin-bottom:35px;padding:0 45px;}
@media (max-width: 540px){
.coupon-wrapper p{font-size:14px!important;}
.coupon-main-box{padding:15px;}
}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
p{margin:0 0 10px;}
:focus{outline:0;}
.Galyon{font-family:Galyon, Helvetica, Arial, sans-serif;}
.Galyon-Bold{font-family:"Galyon Bold", Helvetica, Arial, sans-serif;}
.coupon-wrapper h1{font-size:33px;margin:0;}
.coupon-wrapper h2{font-size:31px;margin:0;}
.coupon-wrapper p{color:#7a7a7a;font-size:16px;margin:8px 0 0 0;line-height:1.2;}
@media (max-width: 540px){
.coupon-wrapper h1{font-size:20px;}
.coupon-wrapper h2{font-size:17px;}
.coupon-wrapper p{font-size:14px!important;}
}
.Galyon{font-family:Galyon, Helvetica, Arial, sans-serif;}
.Galyon-Bold{font-family:"Galyon Bold", Helvetica, Arial, sans-serif;}
.coupon-wrapper h1{font-size:33px;margin:0;}
.coupon-wrapper h2{font-size:31px;margin:0;}
.coupon-wrapper p{color:#7a7a7a;font-size:16px;margin:8px 0 0 0;line-height:1.2;}
.coupon-main-box{width:100%;border-radius:25px;height:124px;box-shadow:5px 10px 10px 0px #dedede;display:flex;align-items:center;justify-content:center;background:#fff;margin-bottom:35px;padding:0 45px;}
aside .sign-up{width:112px;height:32px;border-radius:50px;border:0;background:#f17121;color:#fff;padding-bottom:2px;margin-top:14px;cursor:pointer;}
aside .sign-up:hover{background:#cd4d08;}
.platinum-member{background:#25507c;display:block;text-align:center;height:auto;color:#fff;padding:39px 45px;}
.platinum-member svg{width:195px;height:52px;}
aside .platinum-member h1{display:flex;align-items:center;justify-content:center;font-size:25px;margin:15px 0 8px 0;width:283px;height:50px;background:url(https://img66.anypromo.com/frontimg/2021/Coupon/platinum-text-bg.svg)      no-repeat 0 0;}
aside .platinum-member h2{font-size:20px;padding:0 10px;}
aside .platinum-member ul{list-style-type:none;padding:0;margin:16px auto 22px auto;font-size:18px;text-align:left;max-width:145px;line-height:1.2;}
aside .platinum-member ul svg{width:11px;height:11px;margin-right:5px;}
aside .platinum-member .sign-up{width:154px;height:37px;background:#fff;color:#25507c;font-size:17px;cursor:pointer;display:flex;align-items:center;justify-content:center;margin:0 auto;}
aside .platinum-member .sign-up:hover,aside .platinum-member .sign-up:focus{background:#ccc;text-decoration:none;}
@media (max-width: 992px){
.platinum-member{padding:20px;height:auto;}
aside .platinum-member h1{width:100%;height:auto;padding:0;font-size:20px;background-size:cover;}
aside .platinum-member h2{font-size:15px;}
.platinum-member svg{width:150px;height:40px;}
}
@media (max-width: 540px){
.coupon-wrapper h1{font-size:20px;}
.coupon-wrapper h2{font-size:17px;}
.coupon-wrapper p{font-size:14px!important;}
.coupon-main-box{padding:15px;}
}
</style>
